// SHA-256 (lowercase hex) of a request body. CloudFront OAC signs our POSTs to
// the streaming Function URLs and requires the client to supply the body's
// payload hash in x-amz-content-sha256 — Lambda rejects an unsigned payload.
export async function sha256Hex(body: string): Promise<string> {
  const bytes = new TextEncoder().encode(body);
  const digest = await globalThis.crypto.subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}
